import { net_filemanage } from "@/api/http";

export const API_STFMFM02C05_Initialize = (...params) =>
net_filemanage.post("/api/STFMFM02C05/Initialize", ...params);

export const API_STFMFM02C05_AddFoleder = (...params) =>
net_filemanage.post("/api/STFMFM02C05/AddFolder", ...params);